import usePreviewEpisodeCountdown from './usePreviewEpisodeCountdown';
import './EpisodePlaybackGlass.css';

const PreviewFullEpisodeButton = ({ previewId, onClick, disabled, ...countdownProps }) => {
    const countdown = usePreviewEpisodeCountdown(countdownProps);
    const hintId = `${previewId}-full-episode-hint`;

    return <>
        <button type='button' className='previewFullEpisodeButton episodePlaybackGlass' onClick={onClick}
            disabled={disabled} aria-label='Full episode' aria-describedby={hintId}>
            {countdown && <span className='previewFullEpisodeFill' aria-hidden='true'
                style={{ transform: `scaleX(${1 - countdown.progress})` }} />}
            <span className='previewFullEpisodeLabel'>Full episode</span>
        </button>
        <span id={hintId} className='previewControlHint'>
            Continues the full episode from this moment.
            {countdown && (countdown.running
                ? ` Next preview in ${countdown.secondsRemaining} seconds.`
                : ` Paused, ${countdown.secondsRemaining} seconds remaining until the next preview.`)}
        </span>
    </>;
};

export default PreviewFullEpisodeButton;
